import React, { useEffect, useState } from 'react'

import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'

import { Stack, Typography, Button } from '@mui/material'

import { useToast } from '@/contexts/ToastContext'

import { useAuth } from '@/hooks/useAuth'
import { useBackButton } from '@/hooks/useBackButton'
import { useBiometricAutoLogin } from '@/hooks/useBiometricAutoLogin'

import { HttpError } from '@/api/http'

const AuthPage: React.FC = () => {
  useBackButton()

  const navigate = useNavigate()
  const { state } = useLocation()

  const { show } = useToast()
  const { loginSso } = useAuth()

  const [searchParams] = useSearchParams()
  const ssoCode = searchParams.get('code')

  const [isAuthenticating, setIsAuthenticating] = useState(false)

  const navigateAfterAuth = () => {
    navigate(state?.from ? state.from : '/')
  }

  useBiometricAutoLogin({
    enabled: !ssoCode,
    onSuccess: navigateAfterAuth,
  })

  const handleOnClickLogin = () => {
    navigate('/auth/login', { state })
  }

  const handleOnClickRegister = () => {
    navigate('/auth/register', { state })
  }

  useEffect(() => {
    const code = searchParams.get('code')
    if (code && !isAuthenticating) {
      setIsAuthenticating(true)

      loginSso(code)
        .then(() => {
          navigateAfterAuth()
        })
        .catch((error: HttpError) => {
          show(error.message || 'Ocorreu um erro ao tentar realizar a autenticação!', {
            severity: 'error',
          })

          navigate('/auth/login', { state })
        })
        .finally(() => {
          setIsAuthenticating(false)
        })
    }
  }, [])

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" spacing={4}>
      <Stack direction="column" alignItems="center" textAlign="center">
        <Typography variant="h6" fontWeight="bold" sx={{ whiteSpace: 'nowrap' }}>
          Bem-vindo à MicroRED!
        </Typography>
        <Typography variant="subtitle1">Carregue fácil, Ande mais!</Typography>
      </Stack>

      <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ borderRadius: 20 }}
          onClick={handleOnClickLogin}
          disableElevation
        >
          Entrar
        </Button>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          sx={{ borderRadius: 20 }}
          onClick={handleOnClickRegister}
          disableElevation
        >
          Criar conta
        </Button>
      </Stack>
    </Stack>
  )
}

export default AuthPage
